<template>
    <div class="home-container">
        <el-card shadow="never" class="noBorder">
            <!-- <template #header>
                <div class="card-header">个人首页</div>
            </template> -->
            <el-form ref="formRef" :model="formData" :rules="isForm ? formRules : {}" label-width="120px">
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="用户名">
                            <span>{{ formData.username }}</span>
                        </el-form-item>
                        <el-form-item label="角色">
                            <span>
                                {{
                                    store.getters.userInfo.role_name_lists
                                        ? store.getters.userInfo.role_name_lists.join(',')
                                        : '-'
                                }}
                            </span>
                        </el-form-item>
                        <el-form-item label="部门">
                            <span>
                                {{ store.getters.userInfo.department_show ? store.getters.userInfo.department_show : '-' }}
                            </span>
                        </el-form-item>
                        <el-form-item label="姓名" prop="name">
                            <el-input v-if="isForm" v-model="formData.name"></el-input>
                            <span v-else>{{ store.getters.userInfo.name }}</span>
                        </el-form-item>
                        <!-- <el-form-item label="昵称" prop="nickname">
                            <el-input v-if="isForm" v-model="formData.nickname"></el-input>
                            <span v-else>{{ store.getters.userInfo.nickname }}</span>
                        </el-form-item> -->
                        <el-form-item label="性别" prop="gender">
                            <el-radio-group v-if="isForm" v-model="formData.gender">
                                <el-radio :value="1">男</el-radio>
                                <el-radio :value="2">女</el-radio>
                            </el-radio-group>
                            <span v-else>{{ store.getters.userInfo.gender_show }}</span>
                        </el-form-item>
                        <el-form-item label="联系电话" prop="phone">
                            <el-input v-if="isForm" v-model="formData.phone"></el-input>
                            <div v-else>{{ store.getters.userInfo.phone }}</div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item>
                    <div v-if="!isForm">
                        <el-button type="primary" @click="onEditUserInfo">修改信息</el-button>
                        <el-button type="warning" @click="onEditPassword">修改密码</el-button>
                    </div>
                    <div v-else>
                        <el-button type="primary" :loading="submitLoading" @click="onSubmit">确定</el-button>
                        <el-button @click="onCancel">取消</el-button>
                    </div>
                </el-form-item>
            </el-form>
        </el-card>

        <password-dialog v-model="formDialogVisible" @updateForm="passwordSuccess"></password-dialog>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import { updateUserInfo } from '@/api/sys'
import PasswordDialog from './components/password.vue'

const store = useStore()
// 表单源
const formData = ref({
    id: store.getters.userInfo.id || '',
    username: store.getters.userInfo.username || '',
    name: store.getters.userInfo.name || '',
    gender: store.getters.userInfo.gender || '',
    phone: store.getters.userInfo.phone || '',
    department: store.getters.userInfo.department || '',
    role: store.getters.userInfo.role || '',
    avatar: store.getters.userInfo.avatar || '',
    nickname: store.getters.userInfo.nickname || ''
})
let postAvatar = store.getters.userInfo.avatar || ''
// 验证规则
const formRules = ref({
    name: [
        {
            required: true,
            trigger: 'blur',
            message: '请填写姓名'
        },
        {
            min: 2,
            max: 20,
            message: '输入长度为2-20字',
            trigger: 'blur'
        }
    ],
    nickname: [
        {
            required: true,
            trigger: 'blur',
            message: '请填写昵称'
        }
    ],
    gender: [
        {
            required: true,
            trigger: 'blur',
            message: ''
        }
    ],
    phone: [
        {
            required: true,
            trigger: 'blur',
            message: '请填写联系电话'
        },
        {
            min: 8,
            max: 20,
            message: '输入长度为8-16字',
            trigger: 'blur'
        }
    ]
})
const formRef = ref()
const isForm = ref(false)

const onEditUserInfo = () => {
    isForm.value = true
}
const onCancel = () => {
    isForm.value = false
    formRef.value.resetFields()
}
const formDialogVisible = ref(false)
const onEditPassword = () => {
    formDialogVisible.value = true
}
const passwordSuccess = () => {
    store.dispatch('user/logout')
}

const getPostFormData = () => {
    const postFormData = new FormData()
    postFormData.append('name', formData.value.name)
    postFormData.append('gender', formData.value.gender)
    postFormData.append('phone', formData.value.phone)
    postFormData.append('avatar', postAvatar)
    postFormData.append('nickname', formData.value.nickname)
    return postFormData
}

const submitLoading = ref(false)
const onSubmit = () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const postFormData = getPostFormData()
        const err = await updateUserInfo(postFormData).catch((err) => {
            submitLoading.value = false
            return err
        })
        if (err) return
        // 修改成功
        ElMessage.success('更新成功！')
        store.dispatch('user/getUserInfo')
        onCancel()
        submitLoading.value = false
    })
}

watch(isForm, (newVal) => {
    if (newVal) {
        formData.value = {
            id: store.getters.userInfo.id || '',
            username: store.getters.userInfo.username || '',
            name: store.getters.userInfo.name || '',
            gender: store.getters.userInfo.gender || '',
            phone: store.getters.userInfo.phone || '',
            department: store.getters.userInfo.department || '',
            role: store.getters.userInfo.role || '',
            avatar: store.getters.userInfo.avatar || '',
            nickname: store.getters.userInfo.nickname || ''
        }
    }
})
</script>

<style lang="scss" scoped>
:deep(.el-avatar) {
    // --el-avatar-background-color: none;
    // --el-avatar-bg-color: none;
    img {
        margin: 0 auto;
    }
}

:deep(.el-upload-list__item-preview),
:deep(.el-icon--zoom-in) {
    display: none;
}

:deep(.el-upload-list__item),
:deep(.el-upload--picture-card) {
    width: 120px;
    height: 120px;

    .avatar-uploader-icon {
        margin-top: 36px;
    }
}

.card-header {
    font-size: 0.2rem;
}
</style>
